import GenericDB from './generic-db';

export default class SessionActivityAuditLearningsDb extends GenericDB {
  constructor() {
    super('sessionActivityAuditLearnings');
  }
}
